import { DocumentTransaction } from '@/app/services/supportService/createSupport'
import { formatName } from '@/app/utils/formatName'
import { getImageByType } from '@/app/utils/getImageByType'
import masks from '@/app/utils/masks'
import { EmptyMessage } from '@/view/components/EmptyMessage'

interface TableDocumentsProps {
  data: DocumentTransaction[]
  handleRowClick: (item: DocumentTransaction) => void
}

export const TableDocuments = ({
  data,
  handleRowClick,
}: TableDocumentsProps) => {
  const hasContract = data.some((item) => item.contract)

  return (
    <div className="rounded-lg border">
      {data.length > 0 ? (
        <table className="min-w-full divide-y divide-gray-200 bg-white">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-sm font-medium text-gray-500">
                {hasContract ? 'Contrato' : 'Tipo'}
              </th>
              <th className="px-6 py-3 text-left text-sm font-medium text-gray-500">
                Nome
              </th>
              <th className="px-6 py-3 text-center text-sm font-medium text-gray-500">
                CPF
              </th>
              <th className="px-6 py-3 text-center text-sm font-medium text-gray-500">
                Telefone
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {data.map((item) => (
              <tr
                key={item._id}
                className="cursor-pointer hover:bg-gray-100"
                onClick={() => handleRowClick(item)}
              >
                <td className="whitespace-nowrap px-6 py-4">
                  <div className="flex flex-col items-start gap-1">
                    <span className="text-sm font-semibold">
                      {item.contract || '-'}
                    </span>
                    <img
                      src={getImageByType(item.type)}
                      alt={item.type}
                      className="h-5 object-contain"
                    />
                  </div>
                </td>
                <td className="whitespace-nowrap px-6 py-4">
                  <p className="text-sm">
                    <span className="font-semibold text-blue-600">V</span>{' '}
                    {formatName(item.sellerName)}
                  </p>
                  <p className="text-sm">
                    <span className="font-semibold text-green-600">C</span>{' '}
                    {formatName(item.customerName)}
                  </p>
                </td>
                <td className="whitespace-nowrap px-6 py-4 text-center">
                  <p className="text-sm">{masks.cpf(item.sellerCpf)}</p>
                  <p className="text-sm">{masks.cpf(item.customerCpf)}</p>
                </td>
                <td className="whitespace-nowrap px-6 py-4 text-center">
                  <p className="text-sm">{masks.phone(item.sellerPhone)}</p>
                  <p className="text-sm">{masks.phone(item.customerPhone)}</p>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <EmptyMessage
          title="Nenhuma transação com documentos"
          className="h-[300px]"
        />
      )}
    </div>
  )
}
